import { render, staticRenderFns } from "./ContentModal.vue?vue&type=template&id=97e10f26&scoped=true&"
import script from "./ContentModal.vue?vue&type=script&lang=js&"
export * from "./ContentModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentModal.vue?vue&type=style&index=0&id=97e10f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e10f26",
  null
  
)

export default component.exports